<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/home"></ion-back-button>
    </ion-buttons>
    <ion-title>Make a Difference</ion-title>
    <ion-buttons slot="primary">
      <ion-button [routerLink]="['/chats']"><ion-icon name="chatbox" slot="icon-only"></ion-icon></ion-button>
      <ion-button [routerLink]="['/notifications']"><ion-icon name="notifications"
          slot="icon-only"></ion-icon></ion-button>
      <ion-button [routerLink]="['/account']"><ion-icon name="menu-outline" slot="icon-only"></ion-icon></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="no-padding background-color">
  <ion-grid class="no-padding background-color">
    <ion-row>
      <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <ion-img src="../../../assets/images/DonateSlogan.jpg" class="slogan"></ion-img>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <ion-button color="danger" expand="full" [routerLink]="['/authorities']"><ion-icon name="warning-outline"
            slot="start"></ion-icon>Urgent case? Contact authorities</ion-button>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <ion-card class="post">
          <ion-card-header class="ion-text-center">
            <ion-card-title color="darkmimbo">Support Mimbo's Mission</ion-card-title>
            <ion-card-subtitle color="darkmimbo">In Loving Memory of Mimbo</ion-card-subtitle>
          </ion-card-header>

          <ion-card-content>
            <div class="ion-text-center">
              <ion-text>
                This app is a tribute to Mimbo, a dog who brought unconditional
                love and joy to my life. Mimbo was my everything, and his loss
                in 2021 inspired me to create this platform to help dogs and
                their humans everywhere.</ion-text>
            </div>
            <ion-text>
              <br />
              <b>Why Donate?</b><br /><br />
              Your donations will:
              <ul>
                <li>
                  Sustain the app and website to keep them free for all users.
                </li>
                <li>
                  Support initiatives to aid stray animals in need, providing
                  them with food, shelter, and care.
                </li>
              </ul>
              Every contribution, big or small, helps keep Mimbo’s legacy alive
              and supports a better life for animals in need.
            </ion-text>
          </ion-card-content>
          <div class="ion-text-center">
            <ion-button fill="clear" (click)="donate('mimbo')">Donate</ion-button>
            <ion-button fill="clear" (click)="visit('mimbo')">About Us</ion-button>
          </div>
        </ion-card>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <ion-card class="ion-text-center post">
          <ion-card-header>
            <ion-card-title color="darkmimbo">Give Me a Paw</ion-card-title>
            <ion-card-subtitle color="darkmimbo">Ras el Maten</ion-card-subtitle>
          </ion-card-header>

          <ion-card-content>
            <ion-text>
              Give Me A Paw aim to show the world that animals are not
              disposable, their lives matter and should be valued. Their mission
              is to rescue, rehabilitate, and home in hopes that all animals
              will receive the love and life they deserve. They want to home as
              many dogs as possible as well as reduce the stray population on
              the streets of Lebanon.</ion-text>
          </ion-card-content>

          <ion-button fill="clear" (click)="donate('gmap')">Donate</ion-button>
          <ion-button fill="clear" (click)="visit('gmap')">View Website</ion-button>
        </ion-card>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <ion-card class="post">
          <ion-card-header class="ion-text-center">
            <ion-card-title color="darkmimbo">Animals Lebanon</ion-card-title>
            <ion-card-subtitle color="darkmimbo">Hamra</ion-card-subtitle>
          </ion-card-header>

          <ion-card-content>
            <ion-text>Animals Lebanon's main mission is to enact and enforce
              comprehensive national animal protection and welfare legislation.
              It aims to increase Lebanon's compliance with the regulations of
              the World Animal Health Organization (OIE) and the Convention on
              International Trade in Endangered Species (CITES), while also
              encouraging and enabling civil society to make meaningful
              improvements for animal welfare.</ion-text>
          </ion-card-content>
          <div class="ion-text-center">
            <ion-button fill="clear" (click)="donate('animalslebanon')">Donate</ion-button>
            <ion-button fill="clear" (click)="visit('animalslebanon')">View Website</ion-button>
          </div>
        </ion-card>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <ion-card class="ion-text-center post">
          <ion-card-header>
            <ion-card-title color="darkmimbo">Doggos In Leb</ion-card-title>
            <ion-card-subtitle color="darkmimbo">Jouar El Houz</ion-card-subtitle>
          </ion-card-header>

          <ion-card-content>
            <ion-text>
              Tamara, a dedicated rescuer in Lebanon, has been
              saving and caring for abandoned and abused dogs and cats since
              2018. Many of these rescues are fortunate enough to find loving
              homes locally or abroad, while others remain in boarding
              facilities or foster homes, receiving care until their forever
              families are found. All rescues are fully vaccinated,
              microchipped, and spayed or neutered to ensure their health and
              safety. With monthly expenses exceeding $3,000 for food, shelter,
              medical bills, and transportation, every donation plays a vital
              role in sustaining this mission.
            </ion-text>
          </ion-card-content>

          <ion-button fill="clear" (click)="donate('doggosinleb')">Donate</ion-button>
          <ion-button fill="clear" (click)="visit('doggosinleb')">View Website</ion-button>
        </ion-card>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <ion-card class="ion-text-center post">
          <ion-card-header>
            <ion-card-title color="darkmimbo">Lebanese Wildlife</ion-card-title>
            <ion-card-subtitle color="darkmimbo">Beit Mery</ion-card-subtitle>
          </ion-card-header>

          <ion-card-content>
            <ion-text>
              Lebanese Wildlife treats injured or orphaned local wildlife,
              providing them with the care and rehabilitation they need to
              recover fully. Once they are healthy and strong, they are returned
              to their natural habitat, where they can thrive once again.
              Lebanese Wildlife is dedicated to improving the quality of
              wildlife care in Lebanon, ensuring that each animal has the best
              chance of survival and reintegration into the wild. Their mission
              extends beyond rescue and rehabilitation; they strive to foster
              compassion and understanding within the community. By raising
              awareness about the importance of protecting local wildlife and
              ecosystems, they hope to create a future where humans and nature
              coexist harmoniously.
            </ion-text>
          </ion-card-content>

          <ion-button fill="clear" (click)="donate('lebanesewildlife')">Donate</ion-button>
          <ion-button fill="clear" (click)="visit('lebanesewildlife')">View Website</ion-button>
        </ion-card>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <ion-card class="ion-text-center post">
          <ion-card-header>
            <ion-card-title color="darkmimbo">BETA</ion-card-title>
            <ion-card-subtitle color="darkmimbo">Baabda</ion-card-subtitle>
          </ion-card-header>

          <ion-card-content>
            <ion-text>
              BETA's mission is to strive towards ensuring that one day all
              animals in Lebanon will get the chance to live safely and
              securely. It’s their goal to educate individuals and take direct
              action to help animals in Lebanon live the life they deserve, for
              we all belong to this planet and it is home to all of us.
            </ion-text>
          </ion-card-content>

          <ion-button fill="clear" (click)="donate('beta')">Donate</ion-button>
          <ion-button fill="clear" (click)="visit('beta')">View Website</ion-button>
        </ion-card>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <ion-card class="ion-text-center post">
          <ion-card-header>
            <ion-card-title color="darkmimbo">Alyarz Pet Club (APC)</ion-card-title>
            <ion-card-subtitle color="darkmimbo">Baabda</ion-card-subtitle>
          </ion-card-header>
          <ion-card-content>
            <ion-text>
              Alyarz Pet Club (APC) is a nonprofit, tax-exempt 501(c)(3)
              organization. Its operations are managed in Lebanon by a team of
              dedicated professionals and volunteers, where saved animals are
              given temporary sanctuary to recover from physical injury and
              emotional trauma. Rescued animals are then offered a new home
              after ensuring both adopter and adoptee are well matched.
            </ion-text>
          </ion-card-content>

          <ion-button fill="clear" (click)="donate('apc')">Donate </ion-button>
          <ion-button fill="clear" (click)="visit('apc')">View Website</ion-button>
        </ion-card>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <ion-card class="ion-text-center post">
          <ion-card-header>
            <ion-card-title color="darkmimbo">Carma Dog Shelter</ion-card-title>
            <ion-card-subtitle color="darkmimbo">Tripoli</ion-card-subtitle>
          </ion-card-header>
          <ion-card-content>
            <ion-text>
              Carma Dog Shelter, founded in Tripoli in 2022 by Mia Arawi, rescues and cares for neglected stray dogs in
              one of Lebanon’s most impoverished regions. It provides medical treatment and works to find them permanent
              homes. Despite existing animal protection laws in Lebanon, the shelter struggles with limited funding and
              relies on volunteers and donations to continue its work.
            </ion-text>
          </ion-card-content>

          <ion-button fill="clear" (click)="donate('carma')">Donate </ion-button>
          <ion-button fill="clear" (click)="visit('carma')">View Website</ion-button>
        </ion-card>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <ion-card class="ion-text-center post">
          <ion-card-header>
            <ion-card-title color="darkmimbo">Mashala Shelter</ion-card-title>
            <ion-card-subtitle color="darkmimbo">Nabatieh</ion-card-subtitle>
          </ion-card-header>
          <ion-card-content>
            <ion-text>
              Mashala Shelter, located in Nabatieh in South Lebanon, is run by Houssein Hamze, who singlehandedly cares
              for around 200 rescued dogs. The shelter takes in strays and abandoned pets, especially during times of
              conflict, despite limited resources. Houssein often risks his safety to rescue animals in need and provide
              them with food, care, and shelter.
            </ion-text>
          </ion-card-content>

          <ion-button fill="clear" (click)="donate('mashala')">Donate </ion-button>
          <ion-button fill="clear" (click)="visit('mashala')">View Website</ion-button>
        </ion-card>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <ion-card class="ion-text-center post">
          <ion-card-header>
            <ion-card-title color="darkmimbo">Paws Crossed</ion-card-title>
            <ion-card-subtitle color="darkmimbo">Fanar</ion-card-subtitle>
          </ion-card-header>
          <ion-card-content>
            <ion-text>
              Sandra Mouawad, founder of Paws Crossed, has dedicated over nine years to rescuing and rehabilitating
              abandoned, abused, injured, and neglected dogs and cats across Lebanon. She currently cares for more than
              25 dogs and 50 cats, many of whom have suffered from car accidents, mistreatment, illness, or trauma.
              Sandra provides ongoing medical care, socialization, and emotional healing to help these animals recover
              and thrive
            </ion-text>.
          </ion-card-content>

          <ion-button fill="clear" (click)="donate('pawscrossed')">Donate </ion-button>
          <ion-button fill="clear" (click)="visit('pawscrossed')">View Website</ion-button>
        </ion-card>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <ion-card class="ion-text-center post">
          <ion-card-header>
            <ion-card-title color="darkmimbo">Rescuing in Lebanon</ion-card-title>
            <ion-card-subtitle color="darkmimbo">Beirut</ion-card-subtitle>
          </ion-card-header>
          <ion-card-content>
            <ion-text>
              Sarah (born in 2001) founded Rescuing in Lebanon in 2020 when she wanted to share her success stories of
              the dogs and cats she’s been rescuing and rehoming. Shortly after, Rescuing in Lebanon turned into
              something much bigger and Sarah started rescuing the most abused dogs and cats in Lebanon and shared them
              with the whole world. Sarah is an agriculture student and chose this major so she can use everything she
              learns to be the voice of animals in Lebanon and change the future and make it a better and more peaceful
              space for the animals.
            </ion-text>.
          </ion-card-content>

          <ion-button fill="clear" (click)="donate('rescuinginleb')">Donate </ion-button>
          <ion-button fill="clear" (click)="visit('rescuinginleb')">View Website</ion-button>
        </ion-card>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <ion-card class="ion-text-center post">
          <ion-card-header>
            <ion-card-title color="darkmimbo">Bekaa Shelter Lebanon</ion-card-title>
            <ion-card-subtitle color="darkmimbo">Bekaa</ion-card-subtitle>
          </ion-card-header>
          <ion-card-content>
            <ion-text>
              Bekaa Rescue + Shelter is dedicated to rescuing stray and abandoned animals in the Bekaa Valley, providing
              them with shelter, medical care, and a chance to find loving homes. The team focuses on both healing
              animals from trauma and raising awareness about animal welfare through education and community outreach.
              Their mission is to build a future where all animals are treated with compassion, dignity, and respect.
            </ion-text>.
          </ion-card-content>

          <ion-button fill="clear" (click)="donate('bekaa')">Donate </ion-button>
          <ion-button fill="clear" (click)="visit('bekaa')">View Website</ion-button>
        </ion-card>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <ion-card class="ion-text-center post">
          <ion-card-header>
            <ion-card-title color="darkmimbo">Woof N’ Wags</ion-card-title>
            <ion-card-subtitle color="darkmimbo">Jezzine</ion-card-subtitle>
          </ion-card-header>
          <ion-card-content>
            <ion-text>
              Woof N’ Wags is a no-kill, volunteer-run animal shelter in South Lebanon founded by Ghada and Joe. It
              houses over 300 rescued dogs along with other farm animals saved from abuse and slaughter. The shelter
              responds to community reports of injured or abused animals, offering care and safety despite having no
              government or organizational funding. Amid Lebanon’s economic crisis and regional conflict, Woof N’ Wags
              continues its mission to protect animals from abandonment, suffering, and fear.
            </ion-text>.
          </ion-card-content>

          <ion-button fill="clear" (click)="donate('woofnwags')">Donate </ion-button>
          <ion-button fill="clear" (click)="visit('woofnwags')">View Website</ion-button>
        </ion-card>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <ion-card class="ion-text-center post">
          <ion-card-header>
            <ion-card-title color="darkmimbo">Adopt Don’t Shop</ion-card-title>
            <ion-card-subtitle color="darkmimbo">Dekwaneh</ion-card-subtitle>
          </ion-card-header>
          <ion-card-content>
            <ion-text>
              Adopt Don’t Shop Lebanon is a volunteer-led NGO dedicated to rescuing, treating, and rehoming stray
              animals across Lebanon. Founded in 2018 and officially registered in 2019, the organization promotes
              responsible pet adoption over buying animals from breeders or pet shops. With a strong focus on education,
              community collaboration, and digital outreach, they aim to reform public attitudes toward animal welfare.
              Through their partnership with the French NGO Elias and Friends, they provide medical care, shelter, and
              adoption opportunities for thousands of abandoned and injured animals.
            </ion-text>.
          </ion-card-content>

          <ion-button fill="clear" (click)="donate('adopt')">Donate </ion-button>
          <ion-button fill="clear" (click)="visit('adopt')">View Website</ion-button>
        </ion-card>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <ion-card class="ion-text-center post">
          <ion-card-header>
            <ion-card-title color="darkmimbo">Paris Dog Shelter</ion-card-title>
            <ion-card-subtitle color="darkmimbo">Aramoun</ion-card-subtitle>
          </ion-card-header>
          <ion-card-content>
            <ion-text>
              Paris Dog Shelter is a small rescue run by Mireille Mansour in the heart of Lebanon. It gives a safe home
              to over 100 dogs who were abandoned, injured, or traumatised. Every day, Mireille also feeds stray cats
              and dogs in areas badly affected by the crisis. With the situation getting worse, the shelter is
              struggling to cover rent, food, vet care, and emergency rescues. Mireille is doing everything she can—but
              she cannot do it alone. The shelter urgently needs support to keep going and save more lives.
            </ion-text>.
          </ion-card-content>

          <ion-button fill="clear" (click)="donate('paris')">Donate </ion-button>
          <ion-button fill="clear" (click)="visit('paris')">View Website</ion-button>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>